// extracted by mini-css-extract-plugin
export default {"main":"Companies_main__elUtU","company":"Companies_company__5qo0E","active":"Companies_active__Ly86r","companyplus":"Companies_companyplus__GIKgV"};